import Container from './Container'

export default Container



// WEBPACK FOOTER //
// ./src/components/Container/index.js